import React from 'react';
import Alitalk from '@alife/alpha-alitalk';
import classnames from 'classnames';
import './index.scss';

class ContactSupplierBtn extends React.PureComponent {
  $cs = null;

  componentDidMount() {
    const { isNewVersion } = this.props;

    if (isNewVersion) {
      const html = this.$cs.innerHTML;
      Alitalk.renderList(this.$cs, {
        renderCallback: () => {
          this.$cs.innerHTML = html;
        },
      });
    }
  }

  render() {
    const {
      href,
      i18n,
      domdot,
      className,
      onClick,
      productId,
      productOwnMemberAlitalkEncryptId,
      contactEncryptId,
      contactName,
      photoUrl,
      isNewVersion,
      productIsHang,
    } = this.props;
    return (
      <a
        className={classnames(className, {
          'contact-supplier-with-hang': productIsHang,
        })}
        data-domdot={domdot}
        onClick={onClick}
        href={isNewVersion ? undefined : `${href}&from=detail`}
        data-inquiry-url={
          isNewVersion
            ? `${href}&from=weblite&action=contact_action`
            : undefined
        }
        title="Click to send an inquiry"
        id="J-action-cs"
        rel="nofollow"
        target="_blank"
        data-spm="dmessage"
        data-uid={productOwnMemberAlitalkEncryptId}
        data-pid={productId}
        data-contactid={contactEncryptId}
        data-biztype="1"
        data-contactname={contactName}
        data-contactimg={photoUrl}
        data-productid={productId}
        data-bizid={productId}
        ref={dom => {
          this.$cs = dom;
        }}
      >
        <i className="ui2-icon ui2-icon-left ui2-icon-message" />
        {i18n['mainAction_operate_contact']}
      </a>
    );
  }
}

export default ContactSupplierBtn;
